<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-black dark:tw-fill-white tw-scale-x-[-1]" viewBox="0 0 24 24"><path d="m22.97 16.97-4.39 4.57c-.29.31-.69.46-1.08.46s-.75-.14-1.04-.42a1.5 1.5 0 0 1-.04-2.12L19.75 16H5.5A5.5 5.5 0 0 1 0 10.5v-7a1.5 1.5 0 1 1 3 0v7A2.5 2.5 0 0 0 5.5 13h14.25l-3.33-3.46a1.5 1.5 0 0 1 2.16-2.08l4.41 4.59a3.5 3.5 0 0 1-.02 4.93Z"/></svg>
</template>
